<template>
  <CardFrame class="w-full max-w-xs" :bgColor="'orange'">
    <div class="p-20px">
      <div class="flex flex-col">
        <div class="border-b-orange mb-10px pb-10px border-b-2">
          <component
            :is="headingTag"
            class="text-18 text-navy mb-2 font-bold"
            v-html="data.investmentFundName">
          </component>
          <p class="text-18 mb-2">
            {{ data.underlyingFundName }}
          </p>
          <p class="text-18">(Ticker: {{ data.fundTicker }})</p>
        </div>
        <div>
          <a
            class="text-18 font-bold transition-colors duration-300 hover:text-orange-700 focus:text-orange-700"
            :href="data.fundUrl">
            {{ linkText }}
          </a>
        </div>
      </div>
    </div>
  </CardFrame>
</template>

<script>
import CardFrame from "../Atoms/Cards/CardFrame.vue";
import CardContainer from "../Atoms/Cards/CardContainer.vue";
import { useIsHeaderTag } from "../../compostables/useValidators";

export default {
  components: {
    CardFrame,
    CardContainer,
  },

  props: {
    headingTag: {
      type: String,
      required: false,
      default: "h3",
      validator(value) {
        return useIsHeaderTag(value);
      },
    },
    data: {
      type: Object,
    },
    linkText: {
      type: String,
      required: false,
      default: "View Fund Summary",
    },
  },
};
</script>

<style></style>
